/* eslint-disable no-param-reassign */
/* eslint-disable no-undef */
import m from "mithril";
import data from "../../station-finder/data.json"


export default {
  oninit({ state, attrs }) {
    state.mapId = Math.random()
      .toString()
      .split(".")[1];
  },
  oncreate({ state, attrs }) {
    const points = data
      .respbody
      .STATIONS
      .sort((a, b) => Number(b.DISTANCE) - Number(a.DISTANCE))
      .map((station) => [station, station.STSN_COORDINATES])
      .map(
        (
          [meta, [{ LATI: lat, LONG: long }]]
        ) => ({ lat, long, meta }));

    const markerMap = {};

    attrs.gpsData.map(x => points.push(...x));

    state.map = new window.google.maps.Map(document.getElementById(state.mapId), {
      zoom: 7,
      center: points[points.length - 1]
        ? new google.maps.LatLng(
          points[points.length - 1].lat,
          points[points.length - 1].long
        )
        : null
    });

    let infoWindow; // declare the infoWindow variable here

    points.map(point => {
      const { lat, long: lng, meta } = point;
      // Create a custom marker icon
      const icon = {
        url: 'assets/media/illustrations/rubis-markers.png', // replace with your custom icon URL
        scaledSize: new google.maps.Size(25, 35) // adjust the size to fit your icon
      };

      // Create the marker
      markerMap[meta.STATION_ID] = new google.maps.Marker({
        position: new google.maps.LatLng(lat, lng),
        map: state.map,
        icon,
        title: meta.STATION_NAME
      });

      // Create the info window content
      const contentString = `
              <div style='width:160px;height:125px;'>
              ${meta.STSN_AMENITIES.map(amenity => {
        if (amenity.AMENI_NAME.toLowerCase().includes("accept") || amenity.AMENI_NAME.toLowerCase().includes("test")) {
          return `<br><div style="width: 160px;"><strong>${amenity.AMENI_NAME}</strong></div>`;
        } else {
          const price = Math.floor(Math.random() * 800) + 200; // generate a random price above 200
          return `<div style="width: 160px;"><strong>${amenity.AMENI_NAME}</strong>: KSH: ${price}</div>`;
        }
      }).join('')
        }
          <p>
          <br>
            <a href="https://maps.google.com/maps?saddr=&daddr=${lat},${lng}" target="_blank">
              Get Directions ->
            </a>
          </p>
        </div>`;

      // Add a click event listener to the marker
      markerMap[meta.STATION_ID].addListener("click", () => {
        // Clear the previous info window content
        if (infoWindow) {
          infoWindow.close();
        }

        const headerContent = document.createElement('div');
        headerContent.innerHTML = `<h5>${meta.STATION_NAME}</h5>`;

        // Create a new info window for this marker
        infoWindow = new google.maps.InfoWindow({
          content: contentString,
          headerContent: headerContent
        });


        // Open the new info window
        infoWindow.open(state.map, markerMap[meta.STATION_ID]);

        // Pan the map to the current marker position
        state.map.panTo(markerMap[meta.STATION_ID].getPosition());
        state.map.setZoom(12);

        // Call the markerSelected callback if defined
        if (attrs.markerSelected) {
          attrs.markerSelected(meta);
        }
      });
    });

  },
  view({ state, attrs }) {
    return m(
      "div",
      {
        class: "embed-responsive embed-responsive-16by9",
        style: {
          height: attrs.long !== true ? "" : "calc(300px - 34px)",
          backgroundColor: "rgba(255, 255, 255, 0.5)", // added inline background color
          borderRadius: "10px", // add rounded edges
          boxShadow: "0 0 30px rgba(0, 0, 0, 0.2)" // add a subtle shadow
        }
      },
      m("div", {
        class: "embed-responsive-item",
        id: state.mapId,
        style: {
          width: "100%",
          height: "70vh", // add this to make the map fit 100% to the provided space
          borderRadius: "10px" // add rounded edges to the inner div as well
        }
      })
    );
  }
};
